import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { withOptionalRouter } from 'app/helpers/routing';
import { paginationShape, routerShape } from '@bibliocommons/bc-prop-types';
import { setFocusWithinElement } from '@bibliocommons/utils-accessibility';

import './PaginationLabel.scss';

export class PaginationLabel extends React.PureComponent {
  componentDidUpdate(prevProps) {
    // If autofocus is true, automatically capture focus when the pagination changes.
    if (this.ref && this.props.autoFocus) {
      const { pagination, router } = this.props;

      // When the router is defined (by default), we only respect pagination changes
      // that are due to navigation or location changes. This is to prevent scenarios where data
      // is reloaded behind the scenes from shifting the current focus of the page. eg. after login.
      if (!this.pendingFocusChange) {
        this.pendingFocusChange = router ? prevProps.router?.location !== router.location : true;
      }

      if (this.pendingFocusChange && prevProps.pagination !== pagination) {
        this.pendingFocusChange = false;
        setFocusWithinElement(this.ref);
      }
    }
  }

  render() {
    const { pagination, textKey } = this.props;
    const page = pagination.get('page');
    const count = pagination.get('count');
    const limit = pagination.get('limit');
    const start = (page - 1) * limit + 1;
    const end = Math.min(page * limit, count);

    return (
      <span
        className="cp-pagination-label"
        data-key="pagination-text"
        tabIndex="-1"
        ref={el => {
          this.ref = el;
        }}
      >
        <FormattedMessage id={textKey} values={{ start, end, count }} />
      </span>
    );
  }
}

PaginationLabel.propTypes = {
  pagination: paginationShape.isRequired,
  textKey: PropTypes.string,
  autoFocus: PropTypes.bool,
  router: routerShape
};

PaginationLabel.defaultProps = {
  textKey: 'paginationInfo'
};

export default withOptionalRouter(PaginationLabel);
